import { Box, Pill } from '@moonpig/launchpad-components'
import React, { FC } from 'react'
import { styled } from '@moonpig/launchpad-utils'
import { spacingPx } from '@moonpig/launchpad-theme'
import { PillVariant } from '../../../../types'

const StyledWrapper = styled(Box)`
  position: absolute;
  top: ${spacingPx(4)};
  z-index: 3;
`

const StyledPill = styled(Pill)`
  max-height: ${spacingPx(8)};
`

export const TilePill: FC<{
  pill: {
    label: string
    variant: PillVariant
  }
}> = ({ pill }) => {
  return (
    <StyledWrapper>
      <StyledPill {...pill} />
    </StyledWrapper>
  )
}
